import { Alert, Spin } from "antd";
import { useUnit } from "effector-react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  $dashboard,
  $error,
  $loading,
  dashboardMounted,
  dashboardSessionExpired,
} from "./model";

export default function DashboardDetails() {
  const { id } = useParams();
  const [dashboard, error, loading, onPageMounted, onDashboardExpired] =
    useUnit([
      $dashboard,
      $error,
      $loading,
      dashboardMounted,
      dashboardSessionExpired,
    ]);

  useEffect(() => {
    onPageMounted(id!);
  }, [id, onPageMounted]);

  useEffect(() => {
    const messageHandler = (event: MessageEvent<Record<string, string>>) => {
      if (event.data.action !== "login") {
        return;
      }
      onDashboardExpired(id!);
    };
    window.addEventListener("message", messageHandler);
    return () => {
      window.removeEventListener("message", messageHandler);
    };
  }, [id, onDashboardExpired]);

  return (
    <>
      {loading ? (
        <div className="flex flex-col items-center p-4 lg:px-0 lg:pt-16">
          <Spin></Spin>
        </div>
      ) : null}
      {dashboard !== null ? (
        <iframe
          className="h-screen"
          src={`${dashboard.url}?embedded=true&accessToken=${dashboard.accessToken}&refreshToken=${dashboard.refreshToken}&_ts=${dashboard.ts}`}
        ></iframe>
      ) : (
        <></>
      )}
      {error !== null ? (
        <div className="flex flex-col items-center p-4 lg:px-0 lg:pt-16">
          <Alert
            type="error"
            showIcon
            message="Failed"
            description={error.message}
            className="w-full md:w-1/2"
          ></Alert>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
